import { FunctionComponent } from "react";

import { Button } from "primereact/button";

import { faRightToBracket, faRotate } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./UnauthorizedPage.scss";

interface IUnauthorizedPageProps {
  redirectToLogin: () => Promise<void>;
  errors?: any;
}

export const UnauthorizedPage: FunctionComponent<IUnauthorizedPageProps> = (props: IUnauthorizedPageProps) => {
  const redirectToLogin = () => {
    props.redirectToLogin();
  };

  const reloadPage = () => {
    window.location.reload();
  };

  return (
    <div className="page-unauthorized">
      <h1>You could not be signed in.</h1>

      <p>Please sign in or try to reload the page!</p>

      {!!props.errors && <div className="errors">{props.errors.toString()}</div>}

      <div className="buttons">
        <Button
          onClick={redirectToLogin}
          className="icon-button"
          label="Redirect to login"
          icon={<FontAwesomeIcon icon={faRightToBracket} />}
        />

        <Button
          onClick={reloadPage}
          className="icon-button"
          label="Reload page"
          icon={<FontAwesomeIcon icon={faRotate} />}
        />
      </div>
    </div>
  );
};
